export const POSITIONS = [
  { code: "GK", label: "Gardien" },
  { code: "DC", label: "Défenseur central" },
  { code: "DG", label: "Arrière gauche" },
  { code: "DD", label: "Arrière droit" },
  { code: "MC", label: "Milieu central" },
  { code: "MDC", label: "Milieu défensif" },
  { code: "MOC", label: "Milieu offensif" },
  { code: "MG", label: "Milieu gauche" },
  { code: "MD", label: "Milieu droit" },
  { code: "AG", label: "Ailier gauche" },
  { code: "AD", label: "Ailier droit" },
  { code: "BU", label: "Attaquant" },
];
export const POS_LABEL = Object.fromEntries(POSITIONS.map((p) => [p.code, p.label]));

export const FORMATION = [
  ["GK", 50, 5], ["DG", 14, 17], ["DC", 37, 15], ["DC", 63, 15], ["DD", 86, 17],
  ["MG", 14, 30], ["MC", 37, 29], ["MC", 63, 29], ["MD", 86, 30],
  ["BU", 36, 42], ["BU", 64, 42],
];
export const slotCoords = (i, team) => {
  const [, x, y] = FORMATION[i];
  return team === "white" ? [100 - x, y] : [x, 100 - y];
};

export const TEAM = {
  white: { label: "Blanc", full: "Équipe Blanche", captain: "Capitaine Blanc" },
  black: { label: "Noir", full: "Équipe Noire", captain: "Capitaine Noir" },
};

const TZ = "Indian/Mauritius";
const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);

export const fmtDate = (d, year = false) =>
  cap(new Date(`${d}T12:00:00Z`).toLocaleDateString("fr-FR", {
    weekday: "long", day: "numeric", month: "long", ...(year ? { year: "numeric" } : {}), timeZone: "UTC",
  }));

export const fmtOpens = (iso) => {
  const d = new Date(iso);
  const day = d.toLocaleDateString("fr-FR", { weekday: "long", timeZone: TZ });
  const time = d.toLocaleTimeString("fr-FR", { hour: "2-digit", minute: "2-digit", timeZone: TZ });
  return `${day} à ${time}`;
};

const nf1 = new Intl.NumberFormat("fr-FR", { maximumFractionDigits: 1 });
const nf2 = new Intl.NumberFormat("fr-FR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export const pct = (v) => `${nf1.format(v || 0)} %`;
export const dec2 = (v) => nf2.format(v || 0);

export const DAYS = ["Lundi", "Mardi", "Mercredi", "Jeudi", "Vendredi", "Samedi", "Dimanche"];

export function perms(data, user) {
  const m = data?.match;
  const admin = user?.role === "admin";
  if (!m) return {};
  const scheduled = m.status === "scheduled";
  return {
    admin,
    editStats: m.status !== "cancelled" && (admin || (data.me.is_participant && !m.motm_closed)),
    editLineup: (team) => scheduled && (admin || (!m.teams_locked && m[`captain_${team}`] === user?.id)),
  };
}

export const generalSort = (a, b) =>
  b.points - a.points || b.win_rate - a.win_rate || b.wins - a.wins || b.played - a.played || b.motm - a.motm || b.goals - a.goals;
